import { createContext, useContext, useState, ReactNode, useCallback } from "react";

type AuthModalView = "login" | "signup" | null;

type AuthModalCtx = {
  view: AuthModalView;
  openLogin: () => void;
  openSignup: () => void;
  close: () => void;
  switchView: (v: "login" | "signup") => void;
};

const AuthModalContext = createContext<AuthModalCtx>({
  view: null,
  openLogin: () => {},
  openSignup: () => {},
  close: () => {},
  switchView: () => {},
});

export const AuthModalProvider = ({ children }: { children: ReactNode }) => {
  const [view, setView] = useState<AuthModalView>(null);

  const openLogin = useCallback(() => setView("login"), []);
  const openSignup = useCallback(() => setView("signup"), []);
  const close = useCallback(() => setView(null), []);
  const switchView = useCallback((v: "login" | "signup") => setView(v), []);

  return (
    <AuthModalContext.Provider value={{ view, openLogin, openSignup, close, switchView }}>
      {children}
    </AuthModalContext.Provider>
  );
};

export const useAuthModal = () => useContext(AuthModalContext);